//interface for columns
interface ColumnMeta {
  field: string;
  header: string;
}

// user list column
export const UserListColumns: ColumnMeta[] = [
  { field: "unique_id", header: "User Id" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "address", header: "Adreess" },
  { field: "user_invoice", header: "Charge Invoice" },
  { field: "action", header: "Action" },
];

// client list column
export const ClientListColumns: ColumnMeta[] = [
  { field: "unique_id", header: "Client Id" },
  { field: "user", header: "Supervisor" },
  { field: "company_name", header: "Company Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  // { field: "city", header: "City" },
  // { field: "address", header: "Address" },
  { field: "pay_schema", header: "Pay Scheme" },
  { field: "paystub", header: "Pay Cycle" },
  // { field: "client_charge", header: "Client Payment" },
  { field: "action", header: "Action" },
];

// client list column
export const ClientListColumnsByUser: ColumnMeta[] = [
  { field: "unique_id", header: "Client Id" },
  { field: "company_name", header: "Company Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "client_subs_month_year", header: "Charge Start Date" },
  { field: "address", header: "Address" },
  { field: "bussiness_number", header: "Business No" },
  { field: "pay_schema", header: "Pay Scheme" },
  // { field: "client_charge", header: "Client Payment" },
  { field: "paystub", header: "Pay Cycle" },
  { field: "action", header: "Action" },
];

// client list column
export const ClientListColumnsForUser: ColumnMeta[] = [
  { field: "unique_id", header: "Client Id" },
  { field: "company_name", header: "Company Name" },
  { field: "more_action", header: "More Actions" },
  { field: "cycle_status", header: "Cycle Status" },
  // { field: "paystub", header: "Pay Cycle" },
  // { field: "paystub_pdf", header: "PayStub" },
  // { field: "pd7a", header: "PD7A" },
  // { field: "t4", header: "Reports" },
  // { field: "invoice", header: "Invoice" },
  // { field: "sub_contractor", header: "Sub Contarctor" },
  { field: "client_subs_month_year", header: "Charge Start From" },
  { field: "email", header: "Email" },
  // { field: "phone", header: "Phone" },
  // { field: "address", header: "Address" },
  { field: "bussiness_number", header: "Business No" },
  { field: "pay_schema", header: "Pay Scheme" },
  { field: "action", header: "Action" },
];

// Employee list column
export const EmployeeListColumns: ColumnMeta[] = [
  { field: "unique_id", header: "Employee Id" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone " },
  { field: "joining_date", header: "Joining Date" },
  { field: "wage", header: "Wage" },
  { field: "is_salary", header: "Salary" },
  // { field: "address", header: "Adreess" },
  { field: "emp_status", header: "Emp Status" },
  { field: "sin_number", header: "Sin Number" },
  { field: "province", header: "Province" },
  { field: "city", header: "City" },
  { field: "action", header: "Action" },
];

// Employee list column
export const EmployeeListForUserColumns: ColumnMeta[] = [
  { field: "unique_id", header: "Employee Id" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "joining_date", header: "Joining Date" },
  { field: "sin_number", header: "Sin Number" },
  { field: "wage", header: "Wage" },
  { field: "address", header: "Adreess" },
];

// Employee list for client detail column
export const EmployeeListByClientDetail: ColumnMeta[] = [
  { field: "unique_id", header: "Employee Id" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "joining_date", header: "Joining Date" },
  { field: "address", header: "Adreess" },
  { field: "action", header: "Action" },
];

// PayRoll List Column
export const PayRollListColumns: ColumnMeta[] = [
  { field: "user_id", header: "Employee Name" },
  { field: "pay_period", header: "Pay Period" },
  { field: "is_salary", header: "Salary" },
  { field: "hour", header: "Working Hours" },
  { field: "paystub_url", header: "PayStub" },
];

// PayRoll List Column
export const EmployeePaystubListColumns: ColumnMeta[] = [
  { field: "createdAt", header: "Date" },
  { field: "pay_period", header: "Pay Period" },
  { field: "hour", header: "Working Hours" },
  { field: "paystub_url", header: "Paystub" },
];

// Pay Cycle List Column
export const PayCycleListColumns: ColumnMeta[] = [
  { field: "pay_period", header: "Pay Period" },
  { field: "paycheck_date", header: "PayCheck Date" },
  { field: "working_hour_status", header: "Working Hour Status" },
  { field: "action", header: "Working Hour" },
];

// Pay Cycle List Column
export const PayCycleListColumnsForUser: ColumnMeta[] = [
  { field: "pay_period", header: "Pay Period" },
  { field: "paycheck_date", header: "PayCheck Date" },
  { field: "client_charge_status", header: "Client Payment" },
  { field: "working_hour_status", header: "Working Hour Status" },
  { field: "action", header: "Working Hour" },
];

// Pay Cycle List Column
export const PayCycleListColumnsForAdmin: ColumnMeta[] = [
  { field: "pay_period", header: "Pay Period" },
  { field: "paycheck_date", header: "PayCheck Date" },
  { field: "client_charge_status", header: "Client Payment" },
];

// PayRoll List Column
export const PDAReportListColumns: ColumnMeta[] = [
  { field: "period", header: "Pay Period" },
  { field: "pd7a_url", header: "PDF" },
  { field: "status", header: "Payment Status" },
  { field: "payment_url", header: "Payment" },
];
// holidays list column
export const HolidayListColumns: ColumnMeta[] = [
  { field: "date", header: "Date" },
  { field: "name", header: "Holiday Name" },
  { field: "action", header: "Action" },
];

// client t4PayRoll List Column
export const T4PayRollListColumns: ColumnMeta[] = [
  { field: "user_id", header: "Employee Name" },
  { field: "year", header: "Year" },
  { field: "annualIncome", header: "Annual Income" },
  { field: "annualTax", header: "Tax deduction" },
  { field: "t4_url", header: "T4 Pdf" },
];

// client Employer-t4 List Column
export const EmployerT4ListColumns: ColumnMeta[] = [
  { field: "user_id", header: "Employee Name" },
  { field: "year", header: "Year" },
  { field: "annualIncome", header: "Annual Income" },
  { field: "annualTax", header: "Tax deduction" },
  { field: "t4_url", header: "T4 Pdf" },
];

// t4 summary List Column
export const T4SummaryListColumns: ColumnMeta[] = [
  { field: "payroll_no", header: "PayRoll Number" },
  { field: "t4_url", header: "T4 Summary" },
];

// t4 xml List Column
export const T4XMLListColumns: ColumnMeta[] = [
  { field: "year", header: "Year" },
  { field: "t4_url", header: "T4 XML" },
];

// employee earning summary list column
export const EmployeeEarningSummaryListColumns: ColumnMeta[] = [
  { field: "year", header: "Year" },
  { field: "url", header: "Summary PDF" },
];

// payroll liab balance list column
export const PayrollLiabBalanceListColumns: ColumnMeta[] = [
  { field: "year", header: "Year" },
  { field: "url", header: "Summary PDF" },
];

// payroll transaction details list column
export const PayrollTransactionListColumns: ColumnMeta[] = [
  { field: "year", header: "Year" },
  { field: "url", header: "Summary PDF" },
];

// ROE list column
export const ROEListColumns: ColumnMeta[] = [
  { field: "name", header: "Employee Name" },
  { field: "address", header: "Address" },
  { field: "time_period", header: "Time Period" },
  { field: "url", header: "Summary PDF" },
  { field: "t4blk", header: "ROE BLK" },
  { field: "re_generate_roe", header: "Re-Generate ROE" },
];

// PayRoll List Column
export const EmployeeT4PayRollListColumns: ColumnMeta[] = [
  { field: "year", header: "Year" },
  { field: "annualIncome", header: "Annual Income" },
  { field: "annualTax", header: "Tax Deduction" },
  { field: "t4_url", header: "T4 Pdf" },
];

// invoice list column

export const InvoiceListColumn: ColumnMeta[] = [
  { field: "invoice_no", header: "Invoice No" },
  { field: "date", header: "Date" },
  { field: "due_date", header: "Due Date" },
  { field: "bill_to", header: "Bill To" },
  { field: "bill_email", header: "Email" },
  { field: "total", header: "Total Amount" },
  { field: "payment_received_date", header: "Payment Received Date" },
  { field: "payment_status", header: "Payment Status" },
  { field: "invoice_url", header: "Invoice Pdf" },
  { field: "action", header: "Action" },
];

// invoice payee list column
export const InvoicePayeeListColumn: ColumnMeta[] = [
  { field: "bill_to", header: "Bill To" },
  { field: "bill_email", header: "Email" },
  { field: "bill_phone", header: "Phone" },
  { field: "business_no", header: "Business No" },
  { field: "bill_address", header: "Address" },
  { field: "create_invoice", header: "Create Invoice" },
  { field: "action", header: "Action" },
];

// sub contractor column list
export const SubContractorListColumn: ColumnMeta[] = [
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "sin_no", header: "Sin No/Business No" },
  { field: "gst_no", header: "GST No" },
  { field: "phone", header: "Phone" },
  { field: "address", header: "Address" },
  { field: "payment", header: "Payment" },
  { field: "action", header: "Action" },
];

// sub contractor payment list
export const SubContractorPaymentListColumn: ColumnMeta[] = [
  { field: "name", header: "Payment To" },
  { field: "date", header: "Period End Date" },
  { field: "email", header: "Email" },
  // { field: "phone", header: "phone" },
  // { field: "sin_no", header: "sin Number" },
  // { field: "gst_no", header: "GST Number" },
  // { field: "amount", header: "Amount" },
  { field: "payment_date", header: "Payment Date" },
  { field: "payment_mode", header: "Payment Method" },
  { field: "gst_added", header: "Paid Amount" },
  { field: "gst_amount", header: "Gst Amount" },
  { field: "url", header: "Invoice Pdf" },
  { field: "action", header: "Action" },

  // { field: "payment_status", header: "Payment Status" },
];

// user stripe invoice list
export const userInvoiceListColumn: ColumnMeta[] = [
  { field: "", header: "" },
  { field: "invoice_no", header: "Invoice No" },
  { field: "company_name", header: "Client Name" },
  // {
  //   field: "client_invoices",
  //   header: "Company Names",
  // },
  { field: "invoice_created_date", header: " Created " },
  { field: "invoice_pay_date", header: " Paid " },
  { field: "status", header: " Status" },
  { field: "invoice_url", header: "Invoice Pdf" },
];

// admin dashboard user detail table
export const UserDetailAdminDashboardColumn: ColumnMeta[] = [
  { field: "unique_id", header: "User ID" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "phone" },
  { field: "total_client_charge", header: "Client Charge" },
];

// client list column from user detail navigate from admin dashboard
export const userDetailClientListCol: ColumnMeta[] = [
  { field: "company_name", header: "Company Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "client_charge", header: "Client Charge" },
  { field: "client_subs_month_year", header: "Charge Start from" },
];

// user dashboard client list
export const ClientListUserDashboardColumn: ColumnMeta[] = [
  { field: "company_name", header: "Company Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "phone" },
  { field: "client_charge", header: "Client Charge" },
  { field: "client_subs_month_year", header: "Charge Start from" },
];

// un verified user list
export const UnverifiedUserListColumns: ColumnMeta[] = [
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "address", header: "Address" },
  { field: "action", header: "Action" },
];
